// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-dialog-title {
  flex: 1 1 auto;
  text-align: center;
}

.mat-mdc-dialog-content {
  flex: 1 1 auto;
  text-align: center;
}

.button-space {
  margin: 20px;
}

.info-section {
  font-size: 24px;
  margin-bottom: 20px;
  margin-top: 25px;
}

.mat-mdc-dialog-actions[align=end] {
  justify-content: flex-end;
}
.mat-mdc-dialog-actions[align=center] {
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/mat-modal/mat-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAGE;EACE,yBAAA;AAAJ;AAGE;EACE,uBAAA;AADJ","sourcesContent":[".mat-mdc-dialog-title {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.mat-mdc-dialog-content {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.button-space {\n  margin: 20px;\n}\n\n.info-section {\n  font-size: 24px;\n  margin-bottom: 20px;\n  margin-top: 25px;\n}\n\n.mat-mdc-dialog-actions {\n  &[align=\"end\"] {\n    justify-content: flex-end;\n  }\n\n  &[align=\"center\"] {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
